import React, { useState } from 'react'

import PropTypes from 'prop-types'
import { Box, Paper, Popover } from '@material-ui/core'
import { BlockPicker } from 'react-color'

import constants from 'constants/index'
import useStyles from './styles'

const ColorPicker = ({ value, onChange }) => {
  const { KANBAN_COLUMN_PALETTE_COLORS } = constants.activities

  const classes = useStyles()
  const [anchorEl, setAnchorEl] = useState(null)

  return (
    <>
      <Box
        className={classes.colorTrigger}
        onClick={(e) => setAnchorEl(e.currentTarget)}
      >
        <Box className={classes.colorDot} style={{ backgroundColor: value }} />
      </Box>
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
      >
        <Paper elevation={2}>
          <BlockPicker
            color={value}
            colors={KANBAN_COLUMN_PALETTE_COLORS}
            onChangeComplete={(color) => {
              onChange(color.hex)
              setAnchorEl(null)
            }}
          />
        </Paper>
      </Popover>
    </>
  )
}

ColorPicker.defaultColors = constants.activities.KANBAN_COLUMN_PALETTE_COLORS

ColorPicker.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
}

export default ColorPicker
